import { LoadingButton } from '@mui/lab'
import { Alert, AlertTitle, CircularProgress } from '@mui/material'
import React from 'react'

import theme from 'theme'

export const ServiceErrorRetryAlert: React.FC<{
  alertText: string
  isRetrying: boolean
  onClick: () => void
}> = ({ alertText, isRetrying, onClick }) => {
  return (
    <Alert
      data-test-service-error-retry-alert
      action={
        <LoadingButton
          data-test-service-error-retry-button
          color={isRetrying ? 'primary' : 'inherit'}
          loading={isRetrying}
          loadingIndicator={
            <CircularProgress size={16} sx={{ color: 'error.contrastText' }} />
          }
          size="small"
          variant={isRetrying ? 'contained' : 'outlined'}
          onClick={() => onClick()}
        >
          Retry
        </LoadingButton>
      }
      css={{
        width: 'max-content',
        marginTop: theme.space[3],
        marginLeft: theme.space[3]
      }}
      severity="error"
      variant="filled"
    >
      <AlertTitle>{alertText}</AlertTitle>
    </Alert>
  )
}
